import React, { ReactElement } from "react";
import Checkbox from "@amzn/awsui-components-react-v3/polaris/checkbox";
import { WidgetProps } from "@rjsf/utils";
import { description } from "../utils";

export default function CheckboxWidget(props: WidgetProps): ReactElement {
  return (
    <Checkbox
      data-id={props.id}
      checked={props.value ?? false}
      disabled={props.disabled}
      onChange={e => props.onChange(e.detail.checked)}
      onBlur={() => props.onBlur(props.id, null)}
      onFocus={() => props.onFocus(props.id, null)}
      description={props.hideDescription ? undefined : description(props)}
    >
      {/* Show field label next to the box, not in the FormField */}
      {props.label}
    </Checkbox>
  );
}
